import { Section } from "../types";

import { RenderField } from "./renderField";
import { DIVIDED_STYLES } from "../../ui/layout/detailedPages/styles";

export const RenderSection = (
  section: Section,
  index: number,
  mainBlock?: boolean,
) => {
  const { fields, sections, label, style } = section;

  const styleBackground = style && style.background_color;
  const wihiteBackground = styleBackground
    ? style.background_color === "white"
    : true;
  const coloredBackground = styleBackground
    ? style.background_color !== "transparent"
    : true;

  return (
    <div key={index}>
      {label && mainBlock ? (
        <h2 className="text-primary mt-8 text-xl font-medium leading-10">
          {label}
        </h2>
      ) : (
        <h3 className="mt-6 text-xs font-medium uppercase tracking-widest text-stone-700 dark:text-stone-300">
          {label}
        </h3>
      )}

      {sections &&
        sections.length > 0 &&
        sections.map((section: Section, index: number) =>
          RenderSection(section, index),
        )}

      {fields.length > 0 && (
        <div
          className={`overflow-hidden ${
            coloredBackground &&
            `mt-4 rounded dark:bg-stone-800 sm:rounded-lg ${DIVIDED_STYLES}`
          } ${wihiteBackground && "bg-stone-50"}`}
        >
          {fields.map((field, index) =>
            RenderField(field, index, wihiteBackground),
          )}
        </div>
      )}
    </div>
  );
};
